import { faqData } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-800 rounded-full mb-3">
            帮助中心
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            关于使用羞羞漫画的常见疑问解答
          </p>
        </div>

        <div className="flex flex-col gap-4">
          {faqData.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-2xl p-6 md:p-7"
            >
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-3">
                {item.question}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}